<template>
  <button
    class="md__btn-link bgt p-0 m-0 btn-circle-plus"
    @click.prevent="onClick"
  >
    <svg
      width="10"
      height="10"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 1v12M1 7h12"
        stroke="#3ecfb4"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: "ButtonCirclePlusComponent",
  methods: {
    onClick() {
      this.$emit("onClick");
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-circle-plus {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #eafaf6;
  border: 1px solid #3ecfb4;
  transition: transform 0.2s ease, background 0.15s ease;
  flex-shrink: 0;
  &:hover {
    transform: scale(1.1);
    background: #d6f5ed;
  }
}
</style>
